var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Spotify",
    role: "img",
    viewBox: "0 0 512 512",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#3bd75f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffffff",
    r: 192
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3bd75f",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141 195c75-20 164-15 238 24",
    strokeWidth: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 257c61-17 144-13 203 24",
    strokeWidth: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156 315c54-12 116-17 178 20",
    strokeWidth: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.b8befe6b2560c5f8f52885d313531f2d.svg";
export { ForwardRef as ReactComponent };